import React from 'react';
export function ValueFormatter(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.row[props.column.key]);
}